import { IRootState } from 'affiny-core/modules/state';
import get from 'lodash/get';

export const selectCurrentPage = (state: IRootState) =>
  state.photoRequests.meta.currentPage;

export const selectTotalItem = (state: IRootState): number =>
  get(state, 'photoRequests.meta.total', 0);

export const selectPhotoRequestMemberIds = (state: IRootState) =>
  state.photoRequests.list;

export const selectPhotoRequestMessageId = (
  state: IRootState,
  id: string
): string | undefined =>
  get(state, `photoRequests.entries[${id}].attributes.messageId`);
